export default {
  headerContent: {
    title: 'Bereket Sigorta Seyahat Sağlık Sigortası Ücretleri',
    slogan: "Seyahat Sağlık Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'SEYAHAT SAĞLIK SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Bereket Sigorta Seyahat Sağlık Sigortası',
    description: {
      title: 'Bereket Sigorta Seyahat Sağlık Sigortası Nedir? ',
      content: [
        'Bereket seyahat sağlık sigortası, bireyin yurt içi veya yurt dışına iş, öğrenim veya tatil gibi nedenlerle yapacağı seyahatlerde karşılaşabileceği risklere karşı koruma sağlar.',
        'Seyahat sağlık sigortası, kapsamlı sağlık sigortası planlarının bir parçası olarak sunulur ve bağımsız bir plan olarak satın alınabilir. Seyahat sağlık planları genellikle, acil tıbbi tedavileri kapsayarak, seyahat sırasında öngörülemeyen bir hastalık veya yaralanma durumlara karşı yardımcı olabilecek ek faydalar sunar. ',
        'Bu plan, seyahatiniz sırasında teminat altına alınmış bir hastalık veya yaralanma yaşarsanız ve tedavi tesisleri arasında nakledilmeniz gerekirse tahakkuk eden tıbbi faturaların ödenmesi için tasarlanmıştır. ',
        '***Yurt dışı veya yurt içi seyahatiniz için mevcut olan planların detaylarını teklif alarak karşılaştırmak için bu sayfanın sağ üst kısmında bulunan formu kullanabilirsiniz.'
      ]
    },
    subContent: {
      title: 'Neden Seyahat Sağlık Planı Satın Almalı? ',
      content: [
        {
          paragraph:
            'Her tür seyahat sigortasının avantajları vardır, ancak bir seyahat planlarken doğru planı bulmak önemlidir. Seyahat sağlık planı, yurt dışına seyahat ediyorsanız ve seyahatin gecikmesi nedeniyle iptal veya ek masraflar nedeniyle seyahat masraflarını karşılama konusunda endişe duyuyorsanız harika bir seçenektir. ',
          subList: null
        },
        {
          paragraph:
            'Bagaj veya kesinti için sağlam bir koruma arayanlar, kapsamlı bir plan düşünmelidir. ',
          subList: null
        },
        {
          paragraph:
            'Seyahat tıbbi planları, seyahat edenlerin yurt dışına seyahat ederken yeterli tıbbi bakımı bulmalarına yardımcı olmada mükemmeldir. Her zaman önce güvenli olmayı düşünün. ',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Seyahat Sağlık Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Bereket Sigorta Seyahat Sağlık Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Bereket Sigorta Seyahat Sağlık Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Yurt içi, yurt dışı fark etmeksizin güvence sunan Bereket Sigorta poliçe kapsamı;',
          subList: [
            'Tedavi Masrafları',
            'Acil Durum Ulaşımı',
            'Vefat Nedeniyle Geri Dönüş',
            'Tıbbi Tedaviden Sonra Geri Dönüş',
            'Tıbbi Sebeplerden Ötürü Konaklama Uzatımı',
            'Sigortalının Tedavisinden Ötürü Yakın Akraba Üyelerinin Seyahat Etmesi',
            'Bilgi Ve Organizasyon Hizmetleri',
            'Seyahat İptali (Mücbir Sebep)',
            'Ferdi Kaza (6 Ay -18 Yaş) Ölüm Veya Maluliyet',
            'Ferdi Kaza (19 -65 Yaş) Ölüm Veya Maluliyet Teminatını içerir.'
          ]
        }
      ]
    },
    {
      title:
        'Bereket Sigorta Seyahat Sağlık Sigortasından Kimler Yararlanabilir?',
      content: [
        {
          paragraph:
            'Geleneksel sağlık sigortası ile karıştırılmaması gereken seyahat sağlık sigortası, özellikle seyahat sırasında tıbbi acil durumlar içindir ve yurt dışına seyahat ederken sizi ve bütçenizi korur. ',
          subList: null
        },
        {
          paragraph:
            'Hızlı, basit teklif sürecimiz sayesinde, Bereket Sigorta gücüyle desteklenen seyahat sağlık sigortası ile harika seyahat sigortası almak çok kolay. Seyahat planlayan her aday bu poliçeyi alabilir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Bereket Sigorta Seyahat Sağlık Sigortası Ne Zaman Başlar ve Biter?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası poliçe başlangıç ve bitiş tarihleri arasında geçerlidir. Bu tarihler talep ettiğiniz süre bazında oluşturulur. ',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Seyahat Sağlık Sigortası Ne Zaman Yapılmalıdır?',
      content: [
        {
          paragraph:
            'Kesinlikle! Seyahatinizi rezerve ettikten hemen sonra satın almak en iyi zamandır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Bereket Sigorta Seyahat Durumunda Seyahat Sağlık Sigortasını Yanımda Taşımalı Mıyım?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası poliçesini yanınızda taşımanıza gerek yoktur. Telefonunuzda veya mailinizde bulundurmanız yeterlidir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Bereket Sigorta Seyahat Sağlık Sigortası En Az Kaç Günlük Yapılır?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası en az 3 günlük düzenlenmektedir. Çok sık seyahat ediyorsanız 1 yıllık planları tercih etmeniz size fiyat avantajı sağlayacaktır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Seyahat Sağlık Sigortası Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Sigorta poliçenizin şartlarını bilmek ve anlamak sizin sorumluluğunuzdadır. Küçük yazıları dikkatlice okuyun ve ihtiyacınız olursa yardım uzmanlarımızdan isteyin. ',
          subList: null
        },
        {
          paragraph:
            'Sağladığınız bilgiler doğru ve eksiksiz olmalıdır. Herhangi bir sorunuz varsa, sigorta şirketiyle iletişime geçebileceğiniz gibi konuyu yazılı olarak da açıklamalarını da isteyebilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Alokasko.com olarak tüm sigorta ihtiyaçlarınıza cevap verebilmek için uzman kadromuz ile buradayız! Seyahat sağlık sigortası yaptırmak için teklif formunu doldurmanız yeterlidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Vize Seyahat Sağlık Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Vize sağlık sigortası, yurt dışında kazaen karşılaşabileceğiniz yaralanma veya hastalanma sonucu tedavi masraflarınızı güvence altına alan plandır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Seyahat Sağlık Sigortası Kaç Gün Geçerlidir?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası sigortalının talebine göre yapılmaktadır. En az 3 gün olarak düzenlenebilen bu sigorta 1 yıllık da düzenlenebilmektedir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Kaza ve Hastalık Durumlarında Bereket Sigorta Seyahat Sağlık Sigortası Nasıl Kullanılır?',
      content: [
        {
          paragraph:
            'Bereket Sigorta kapsamında satın aldığınız seyahat sağlık sigortasından kaza veya hastalık durumunda yararlanabilirsiniz. Sigorta şirketinin anlaşmalı hastane ağını kontrol ederek bulunduğunuz bölgedeki kuruma gitmeniz yeterlidir.',
          subList: null
        },
        {
          paragraph:
            'Seyahat sağlık sigortanız olduğunu bildirmeniz sonucunda gerekli tedavi ve tetkiklerden poliçe limitleri dâhilinde yararlanabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Bereket Sigorta Seyahat Sağlık Sigortası Hesaplama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası hesaplaması seyahat edilecek ülke bilgileri, seyahat süresi ve sigortalanmak isteyen kişinin bilgileri doğrultusunda hesaplanmaktadır. İlettiğiniz bilgiler doğrultusunda en ucuz seyahat sağlık sigortası fiyatı hesaplanır.  ',
          subList: null
        }
      ]
    },
    {
      title: 'Seyahat Sağlık Sigortası Prim Ödemesi Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Seyahat sigortanızın ödemesini kredi kartınızdan veya nakit olarak yapabilirsiniz. ',
          subList: null
        }
      ]
    },
    {
      title:
        'Online Seyahat Sağlık Sigortası Aldım, Seyahatimi Ertelemem Gerekti Ne Yapmalıyım?',
      content: [
        {
          paragraph:
            'Seyahatini ertelemek zorunda kaldığınız zaman poliçenizi iptal ettirmeniz mümkünüdür. Sigorta danışmanınızı arayarak iptal işlemini gerçekleştirebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Seyahat Sağlık Sigortası İptali Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası iptali poliçe başlamadan en geç bir gün önce yapılabilmektedir. Poliçe başlamadan önce sigorta satın almış olduğunuz acenteyi arayarak iptalini talep edebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Bereket Sigorta Seyahat Sağlık Sigortası Ücretleri Nasıl Belirlenir?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası sigortalı bilgileri ve poliçe kapsamına göre belirlenmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Seyahat Sağlık Sigortası Fiyatı Ne Kadar?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası şirketleri politikalarına, sigortalı bilgilerine ve seyahat edilecek ülkeye göre değişmektedir.',
          subList: null
        },
        {
          paragraph:
            'Seyahat sağlık sigortası fiyatı almak isteyen müşterilerimiz alokasko.com üzerinden başvuru formu doldurabilir veya 0216 371 67 77 numaralı hattan uzman danışmanımızla iletişime geçebilir.',
          subList: null
        }
      ]
    }
  ]
}
